import * as React from 'react'
import g from 'glamorous'
import { Table } from 'react-bootstrap'
import * as moment from 'moment'

import { BASIC } from '../../constants/DateFormat'
import { LoanQueryResult } from '../../components/queries/LoanQuery'
import {
  computeState,
  Transaction,
  initialState,
  LoanType,
  TransactionState,
  processTransactions
} from '../../utils/transactions'
import { moneyFormat } from '../../utils/format'

export type TransactionTableProps = {
  loan: Exclude<LoanQueryResult['loan'], null>
}

const TdRight = g.td(({ theme }) => ({
  textAlign: 'right'
}))

const TrNoHover = g.tr(() => ({
  border: '1px solid white',
  ':hover': {
    backgroundColor: 'white !important'
  }
}))

interface ViewItem {
  transaction: Transaction
  state: TransactionState
  prevState: TransactionState
}

const TransactionTable: React.SFC<TransactionTableProps> = ({ loan }) => {
  const type = loan.interval == null ? LoanType.CLASSIC : LoanType.INTERVAL
  const mappedTransactions = processTransactions(loan)

  const viewData: ViewItem[] = []

  let previousState = initialState

  for (let i = 0; i < mappedTransactions.length; i++) {
    const transaction = mappedTransactions[i]
    const newState = computeState(type, transaction, previousState)

    viewData.push({ transaction, state: newState, prevState: previousState })

    previousState = newState
  }

  return (
    <Table id="transactions-table" striped={true} bordered={true} condensed={true} hover={true}>
      <thead>
        <tr>
          <th>Dne</th>
          <th>Splátka</th>
          <th>Způsob vrácení</th>
          {type === LoanType.CLASSIC && <th>Úrok</th>}
          <th>Zůstatek jistiny</th>
        </tr>
      </thead>
      <tbody>
        {viewData.map(({ transaction, prevState, state }) => (
          <tr key={transaction.id}>
            <td>{moment(transaction.createdOn).format(BASIC)}</td>
            <TdRight>
              {transaction.type === 'PAYMENT'
                ? moneyFormat(transaction.amount)
                : ''}
            </TdRight>
            <td>
              {transaction.type !== 'INTERVAL_INTEREST'
                ? transaction.description
                : 'Úrok'}
            </td>
            {type === LoanType.CLASSIC && (
              <TdRight>
                {transaction.type === 'PAYMENT'
                  ? moneyFormat(
                      transaction.amount - (prevState.amount - state.amount)
                    )
                  : ''}
              </TdRight>
            )}
            <TdRight className="amount">{moneyFormat(state.amount)}</TdRight>
          </tr>
        ))}
        {type === LoanType.CLASSIC && (
          <TrNoHover>
            <td colSpan={2} style={{ border: '0px' }} />
            <td style={{ border: '0px', textAlign: 'right' }}>
              Celk. úrok:{' '}
              {moneyFormat(viewData.reduce(
                (sum, { transaction, prevState, state }) =>
                  transaction.type === 'PAYMENT'
                    ? sum +
                      transaction.amount -
                      (prevState.amount - state.amount)
                    : 0,
                0
              ))}
            </td>
            <td style={{ border: '0px' }} />
          </TrNoHover>
        )}
      </tbody>
    </Table>
  )
}

export default TransactionTable



// WEBPACK FOOTER //
// ./src/screens/loanDetail/TransactionTable.tsx